export default __webpack_public_path__ + "static/media/YouRock_Stamp.055bcc66.png";